import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import Swal from "sweetalert2";
import Loader from "../Loader/Loader";
import { FaTrashAlt } from "react-icons/fa";
import ReactPaginate from "react-paginate";

function Compaign() {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [compaign, setCompaign] = useState({
    name: "",
    description: "",
    status: true,
  });
  const [compaignError, setCompaignError] = useState({
    nameError: "",
    descriptionError: "",
  });
  const [loading, setLoading] = useState(false);
  const [allCampaign, setAllCampaign] = useState([]);
  const [editingCampaign, setEditingCampaign] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  const [filters, setFilters] = useState({
    name: "",
    campaign_code: "",
    status: "",
    dateFrom: "",
    dateTo: "",
  });
  const [filterKey, setFilterKey] = useState(0);

  // campaign table headers
  const tableHeader = {
    campaign_code: "Campaign Code",
    name: "Campaign Name",
    description: "Campaign Description",
    status: "Status",
    leads_count: "Leads Count",
    created_at: "Create at",
    actions: "Actions",
  };

  useEffect(() => {
    const perms = getPermissions();
    if (perms) {
      setPermissions(perms);
    }
  }, []);

  useEffect(() => {
    if (pagination.currentPage > 0) {
      getAllCampaign();
    }
  }, [pagination.currentPage, pagination.perPage, filterKey]);

  // handle filters
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const clearFilters = () => {
    setFilters({
      name: "",
      status: "",
      dateFrom: "",
      dateTo: "",
      campaign_code: "",
    });
    setFilterKey((prev) => prev + 1);

    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
  };

  const applyFilters = () => {
    setFilterKey((prev) => prev + 1);

    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
  };
  // handle page change
  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  // getAllCampaign
  const getAllCampaign = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.currentPage,
        per_page: pagination.perPage,
        ...filters,
      };

      Object.keys(params).forEach(
        (key) => params[key] === "" && delete params[key]
      );
      const response = await apiUrl.get("/getAllCampaign", { params });

      if (response?.status) {
        setAllCampaign(response?.data?.data);
        const MetaData = response?.data?.pagination;

        setPagination((prev) => ({
          ...prev,
          total: MetaData?.total ?? 0,
          lastPage: MetaData?.lastPage,
          perPage: MetaData?.perPage,
          currentPage: MetaData?.currentPage,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  //   handle input change
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setCompaign({
      ...compaign,
      [name]: type === "checkbox" ? checked : value,
    });

    if (value.trim()) {
      setCompaignError((prev) => ({
        ...prev,
        [name + "Error"]: "",
      }));
    }
  };

  // delete a campaign
  const deleteCampaign = async (campaignId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiUrl.delete(`/deleteCampaign/${campaignId}`);

          if (response.data.status) {
            Swal.fire({
              title: "Deleted!",
              text: response.data.message,
              icon: "success",
              timer: 3000,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
            });
            getAllCampaign();
          }
        } catch (error) {
          Swal.fire(
            "Error!",
            error.response?.data?.message || "Failed to delete campaign.",
            "error"
          );
        }
      }
    });
  };

  // update campaign
  const updateCampaign = async () => {
    let valid = true;
    const newErrors = {
      nameError: "",
      descriptionError: "",
    };

    if (!compaign.name || !compaign.name.trim()) {
      newErrors.nameError = "Please enter a campaign name.";
      valid = false;
    }
    if (!compaign.description || !compaign.description.trim()) {
      newErrors.descriptionError = "Please enter a campaign description.";
      valid = false;
    }

    setCompaignError(newErrors);

    if (valid) {
      setLoadingButton(true);
      try {
        const response = await apiUrl.put(
          `/updateCampaign/${editingCampaign.id}`,
          {
            name: compaign.name,
            description: compaign.description,
            status: compaign.status,
          }
        );

        if (response.data?.status) {
          setOpenModal(false);
          Swal.fire({
            title: response.data.message,
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
            toast: true,
            position: "top-end",
          });
          getAllCampaign();
        }
      } catch (error) {
        console.error("Update failed:", error);
        Swal.fire("Error", "Failed to update campaign", "error");
      } finally {
        setLoadingButton(false);
      }
    }
  };
  //   savecompaign leads
  const saveCompaignLead = async () => {
    let valid = true;
    const newErrors = {
      nameError: "",
      descriptionError: "",
    };
    if (!compaign.name || !compaign.name.trim()) {
      newErrors.nameError = "Please enter a campaign name.";
      valid = false;
    }

    if (!compaign.description || !compaign.description.trim()) {
      newErrors.descriptionError = "Please enter a campaign description.";
      valid = false;
    }
    setCompaignError(newErrors);
    if (valid) {
      setLoadingButton(true);

      try {
        const response = await apiUrl.post("/addCampaign", compaign);
        if (response?.status) {
          setOpenModal(false);
          Swal.fire({
            title: response?.data?.message,
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
            toast: true,
            position: "top-end",
          });
          getAllCampaign();
        } else {
          console.error("There is some error while saving campaign");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingButton(false);
      }
    }
  };

  return (
    <>
      <div className="container-fluid px-2 py-3">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-12 px-4">
            <div className="d-flex items-center justify-content-between gap-2">
              <div className="d-flex align-items-center mb-4">
                <a
                  className="btn btn-link p-0 me-3"
                  onClick={() => navigate("/leads")}
                  style={{ textDecoration: "none" }}
                >
                  <FaIcons.FaArrowAltCircleLeft size={22} className="me-1" />
                  <span className="fw-bold">Back</span>
                </a>
                <h2 className="mb-0 fw-bold">Campaigns</h2>
              </div>
            </div>

            {/* Add comaign and the tbale */}
            <div className="d-flex justify-content-end">
              {!!permissions.delete_campaign_leads && (
                <button
                  onClick={() => {
                    setEditingCampaign(null);
                    setCompaign({ name: "", description: "", status: true });
                    setCompaignError({ nameError: "", descriptionError: "" });
                    setOpenModal(true);
                  }}
                  className="btn btn-primary"
                >
                  Add Campaign
                </button>
              )}
            </div>
          </div>
          <div
            className="card mb-4 mt-2"
            style={{
              border: "none",
              borderRadius: "1rem",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            }}
          >
            {/* filters */}
            <div className="card-body p-4">
              {/* Flex Container for Filters */}
              <div
                className="d-flex flex-wrap align-items-end gap-3"
                style={{ marginBottom: "1rem" }}
              >
                {/* Campaign Code */}
                <div style={{ flex: "1 1 200px" }}>
                  <label
                    className="form-label"
                    style={{
                      fontWeight: 500,
                      color: "#374151",
                      fontSize: "0.875rem",
                    }}
                  >
                    Campaign Code
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g., CAMPAIGN-2025-0001"
                    value={filters.campaign_code}
                    onChange={(e) =>
                      handleFilterChange("campaign_code", e.target.value)
                    }
                  />
                </div>

                {/* Campaign Name */}
                <div style={{ flex: "1 1 200px" }}>
                  <label
                    className="form-label"
                    style={{
                      fontWeight: 500,
                      color: "#374151",
                      fontSize: "0.875rem",
                    }}
                  >
                    Campaign Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name..."
                    value={filters.name}
                    onChange={(e) => handleFilterChange("name", e.target.value)}
                  />
                </div>

                {/* Status */}
                <div style={{ flex: "1 1 120px" }}>
                  <label
                    className="form-label"
                    style={{
                      fontWeight: 500,
                      color: "#374151",
                      fontSize: "0.875rem",
                    }}
                  >
                    Status
                  </label>
                  <select
                    className="form-select"
                    value={filters.status}
                    onChange={(e) =>
                      handleFilterChange("status", e.target.value)
                    }
                  >
                    <option value="">All Status</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                {/* Date Range */}
                <div style={{ flex: "1 1 200px" }}>
                  <label
                    className="form-label"
                    style={{
                      fontWeight: 500,
                      color: "#374151",
                      fontSize: "0.875rem",
                    }}
                  >
                    Created Date Range
                  </label>
                  <div className="d-flex gap-2 align-items-center">
                    {/* Start Date */}
                    <div style={{ flex: 1 }}>
                      <input
                        type="date"
                        className="form-control"
                        value={filters.dateFrom}
                        onChange={(e) =>
                          handleFilterChange("dateFrom", e.target.value)
                        }
                      />
                    </div>

                    <span style={{ color: "#9ca3af", fontWeight: "500" }}>
                      to
                    </span>

                    {/* End Date */}
                    <div style={{ flex: 1 }}>
                      <input
                        type="date"
                        className="form-control"
                        value={filters.dateTo}
                        onChange={(e) =>
                          handleFilterChange("dateTo", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex justify-content-end gap-2">
                <button
                  onClick={clearFilters}
                  className="btn btn-light"
                  style={{ border: "1px solid #d1d5db", fontWeight: 500 }}
                >
                  Clear All
                </button>
                <button
                  onClick={applyFilters}
                  className="btn btn-primary"
                  style={{ fontWeight: 500 }}
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
          {/* campaign table */}
          <div className="mt-2">
            <div
              className="table-responsive mb-2"
              style={{ borderRadius: "1rem" }}
            >
              <table className="table table-bordered table-hover bg-white mb-0">
                <thead className="table-dark">
                  <tr>
                    {Object.entries(tableHeader).map(([key, label]) => (
                      <th
                        key={key}
                        style={{
                          padding: "1rem",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          border: "none",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        {label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan={Object.keys(tableHeader).length + 1}
                        className="text-center py-5"
                      >
                        <Loader />
                      </td>
                    </tr>
                  ) : allCampaign.length === 0 ? (
                    <tr>
                      <td
                        colSpan={Object.keys(tableHeader).length + 1}
                        className="text-center py-5"
                      >
                        <div
                          style={{
                            color: "#64748b",
                            fontSize: "1rem",
                            fontWeight: "500",
                          }}
                        >
                          No Campaigns found
                        </div>
                        <div
                          style={{
                            color: "#94a3b8",
                            fontSize: "0.875rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          Adjust filters to see results
                        </div>
                      </td>
                    </tr>
                  ) : (
                    allCampaign.map((camp) => (
                      <tr
                        key={camp.id}
                        style={{
                          transition: "background-color 0.2s ease",
                          height: "72px",
                          cursor: "pointer",
                        }}
                      >
                        {/* campaign code */}
                        <td
                          style={{
                            width: "15%",
                            whiteSpace: "normal",
                            padding: "0.25rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "500",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                              }}
                            >
                              {camp.campaign_code}
                            </div>
                          </div>
                        </td>
                        {/* campaign name */}
                        <td
                          style={{
                            width: "20%",
                            whiteSpace: "normal",
                            padding: "0.25rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "500",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                              }}
                            >
                              {camp.name}
                            </div>
                          </div>
                        </td>
                        {/* campaign description */}
                        <td
                          style={{
                            width: "25%",
                            whiteSpace: "normal",
                            padding: "0.25rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "500",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                              }}
                            >
                              {camp.description}
                            </div>
                          </div>
                        </td>
                        {/* comapign status */}
                        <td
                          style={{
                            width: "5%",
                            whiteSpace: "normal",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "500",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                              }}
                            >
                              {camp.status === 1 ? (
                                <span
                                  className="badge bg-success"
                                  style={{
                                    fontSize: "0.85rem",
                                    padding: "0.5em 0.75em",
                                  }}
                                >
                                  Active
                                </span>
                              ) : (
                                <span
                                  className="badge bg-danger"
                                  style={{
                                    fontSize: "0.85rem",
                                    padding: "0.5em 0.75em",
                                  }}
                                >
                                  Inactive
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                        {/* leads count */}
                        <td
                          style={{
                            width: "10%",
                            whiteSpace: "normal",
                            padding: "0.25rem",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "500",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                              }}
                            >
                              {camp.leads_count}
                            </div>
                          </div>
                        </td>
                        {/* created at */}
                        <td
                          style={{
                            width: "15%",
                            whiteSpace: "normal",
                            padding: "0.25rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontWeight: "500",
                                color: "#1e293b",
                                fontSize: "0.9rem",
                              }}
                            >
                              {new Date(camp.created_at).toLocaleDateString(
                                "en-US",
                                {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}{" "}
                            </div>
                          </div>
                        </td>
                        <td
                          style={{
                            width: "10%",
                            whiteSpace: "normal",
                            padding: "0.25rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <button
                            className="btn btn-danger size-12 m-1"
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteCampaign(camp.id);
                            }}
                            title="Delete Campaign"
                          >
                            <FaTrashAlt size={12} color="#ffffffed" />
                          </button>
                          <button
                            className="btn btn-primary size-12 m-1"
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditingCampaign(camp);
                              setCompaign({
                                name: camp.name,
                                description: camp.description,
                                status: Boolean(camp.status),
                              });
                              setCompaignError({
                                nameError: "",
                                descriptionError: "",
                              });
                              setOpenModal(true);
                            }}
                          >
                            <FaIcons.FaPencilAlt size={12} color="#ffffffed" />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Modal to save the campaign */}
          {openModal && (
            <>
              {/* Backdrop */}
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1040,
                }}
                onClick={() => setOpenModal(false)}
              />
              <div
                className="modal fade show d-block"
                tabIndex={-1}
                role="dialog"
                style={{ zIndex: 1050 }}
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-lg"
                  style={{ maxWidth: 500 }}
                >
                  <div
                    className="modal-content border-0 rounded-4 shadow"
                    style={{ overflow: "hidden" }}
                  >
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <div>
                        <h5 className="modal-title" style={{ fontWeight: 700 }}>
                          {editingCampaign ? "Edit Campaign" : "Add Campaign"}
                        </h5>
                        <div className="text-muted" style={{ fontSize: 12 }}>
                          Please create the campaign first, then add leads to it
                          later.
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                      />
                    </div>

                    <div className="modal-body">
                      {/* Top summary */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "20px",
                          paddingLeft: "15px",
                          paddingRight: "15px",
                        }}
                      >
                        {/* name of compaign */}
                        <div>
                          <label htmlFor="campaign_name" className="ms-1">
                            Campaign Name <span className="text-danger">*</span>
                          </label>
                          <input
                            value={compaign.name}
                            type="text"
                            id="compaign_name"
                            name="name"
                            className={`form-control ${
                              compaignError.nameError ? "is-invalid" : ""
                            }`}
                            placeholder="e.g., Fall 2025 Intake – Canada Student Visa Drive"
                            onChange={handleInputChange}
                          />
                          {compaignError.nameError && (
                            <div
                              className="text-danger"
                              style={{
                                fontSize: "0.875em",
                                marginTop: "0.25rem",
                              }}
                            >
                              {compaignError.nameError}
                            </div>
                          )}
                        </div>
                        {/* description of compaign */}
                        <div>
                          <label className="ms-1">
                            Compaign Description{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <textarea
                            value={compaign.description}
                            name="description"
                            onChange={handleInputChange}
                            className={`form-control ${
                              compaignError.descriptionError ? "is-invalid" : ""
                            }`}
                            rows={4}
                            id="compaign_description"
                            placeholder="e.g., Targeting students with 60%+ academics, IELTS 6.5+, budget 15–25 Lakh INR. Focus on Canada PR-oriented programs."
                          ></textarea>
                          {compaignError.descriptionError && (
                            <div
                              className="text-danger"
                              style={{
                                fontSize: "0.875em",
                                marginTop: "0.25rem",
                              }}
                            >
                              {compaignError.descriptionError}
                            </div>
                          )}
                        </div>
                        {/* the status either it is true or false */}
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "1rem" }}
                        >
                          <label
                            className="ms-1 mb-0"
                            htmlFor="switchCheckChecked"
                          >
                            Status <span className="text-danger">*</span>
                          </label>
                          <div className="form-check form-switch mb-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="switchCheckChecked"
                              checked={compaign.status}
                              onChange={handleInputChange}
                              name="status"
                              style={{
                                height: "1.5em",
                                width: "3em",
                                padding: "0.15em",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Footer actions */}
                    <div
                      className="modal-footer"
                      style={{
                        background: "#f7f8fa",
                        borderTop: "1px solid #eef2f6",
                      }}
                    >
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setOpenModal(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={
                          editingCampaign ? updateCampaign : saveCompaignLead
                        }
                      >
                        {loadingButton ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            {editingCampaign ? "Updating" : "Saving"}
                          </>
                        ) : (
                          <>{editingCampaign ? "Update" : "Save"}</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {/* Pagination Section */}
        <div className="row align-items-center mb-5 mt-2">
          <div className="col-auto">
            <select
              value={pagination?.perPage}
              onChange={handlePerPageChange}
              className="form-select"
              style={{ minWidth: 80 }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
          <div className="col-auto text-muted">
            Page {pagination.currentPage} – Showing{" "}
            {Math.min(
              pagination.perPage,
              pagination.total -
                (pagination.currentPage - 1) * pagination.perPage
            )}{" "}
            of {pagination.total} entries
          </div>
          <div className="col">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={pagination.lastPage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageChange}
              forcePage={pagination.currentPage - 1}
              containerClassName={"pagination justify-content-end mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Compaign;
